import React, { useEffect, useState } from 'react';
import { styles } from './preferences-styles';
import { Button as MuiButton, Grid } from '@material-ui/core';
import { ReactComponent as NormalVision } from '../media/NormalVision.svg';
import { ReactComponent as DeuteranopiaVision } from '../media/DeuteranopiaVision.svg';
import { ReactComponent as ProtanopiaVision } from '../media/ProtanopiaVision.svg';
import { ReactComponent as TritanopiaVision } from '../media/TritanopiaVision.svg';
import RadioButton from './radio-button';
import { CashierPreferenceLevel } from '../../common/enumerations/cashier-preference-level';
import { CashierPreferences } from '../../common/interfaces/dtos/CashierPreferences';

const ColorBlindnessPreferences: React.FC<ColorBlindnessPreferencesProps> = (
  props,
): JSX.Element => {
  const classes = styles();
  const { userPreferences, updatePreferences } = props;
  const [constrastLevel, setConstrastLevel] = useState<CashierPreferenceLevel>(
    userPreferences.contrastLevel,
  );

  useEffect(() => {
    updatePreferences('contrastLevel', constrastLevel);
  }, [constrastLevel, updatePreferences]);

  return (
    <Grid>
      <Grid
        container
        direction='row'
        className={classes.cashierPreferencesColorBlindnessContentContainer}
        data-testid='color-blindness-preferences-container'
      >
        <Grid item xs={6} className={classes.optionsContainer}>
          <MuiButton
            centerRipple
            onClick={() => {
              setConstrastLevel(CashierPreferenceLevel.Zero);
            }}
          >
            <NormalVision data-testid='normal-image' className={classes.colorBlindnessImages} />
          </MuiButton>
          <Grid
            container
            alignItems='baseline'
            className={classes.cashierPreferencesColorBlindnessOptionRadioButtonContainer}
          >
            <MuiButton
              data-testid='normal-image-button'
              className={classes.cashierPreferencesOptionRadioButton}
              centerRipple
              onClick={() => {
                setConstrastLevel(CashierPreferenceLevel.Zero);
              }}
            >
              Normal Mode
              <RadioButton isSelected={constrastLevel === CashierPreferenceLevel.Zero} />
            </MuiButton>
          </Grid>
        </Grid>
        <Grid item xs={6} className={classes.optionsContainer}>
          <MuiButton
            centerRipple
            onClick={() => {
              setConstrastLevel(CashierPreferenceLevel.One);
            }}
          >
            <DeuteranopiaVision
              data-testid='deuteranopia-image'
              className={classes.colorBlindnessImages}
            />
          </MuiButton>
          <Grid
            container
            alignItems='baseline'
            className={classes.cashierPreferencesColorBlindnessOptionRadioButtonContainer}
          >
            <MuiButton
              data-testid='deuteranopia-image-button'
              className={classes.cashierPreferencesOptionRadioButton}
              centerRipple
              onClick={() => {
                setConstrastLevel(CashierPreferenceLevel.One);
              }}
            >
              Deuteranopia Mode
              <RadioButton isSelected={constrastLevel === CashierPreferenceLevel.One} />
            </MuiButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        className={classes.cashierPreferencesColorBlindnessContentContainer}
        data-testid='cashier-preferences-container'
      >
        <Grid item xs={6} className={classes.optionsContainer}>
          <MuiButton
            centerRipple
            onClick={() => {
              setConstrastLevel(CashierPreferenceLevel.Two);
            }}
          >
            <ProtanopiaVision
              data-testid='protanopia-image'
              className={classes.colorBlindnessImages}
            />
          </MuiButton>
          <Grid
            container
            alignItems='baseline'
            className={classes.cashierPreferencesColorBlindnessOptionRadioButtonContainer}
          >
            <MuiButton
              data-testid='protanopia-image-button'
              className={classes.cashierPreferencesOptionRadioButton}
              centerRipple
              onClick={() => {
                setConstrastLevel(CashierPreferenceLevel.Two);
              }}
            >
              Protanopia Mode
              <RadioButton isSelected={constrastLevel === CashierPreferenceLevel.Two} />
            </MuiButton>
          </Grid>
        </Grid>
        <Grid item xs={6} className={classes.optionsContainer}>
          <MuiButton
            centerRipple
            onClick={() => {
              setConstrastLevel(CashierPreferenceLevel.Three);
            }}
          >
            <TritanopiaVision
              data-testid='tritanopia-image'
              className={classes.colorBlindnessImages}
            />
          </MuiButton>
          <Grid
            container
            alignItems='baseline'
            className={classes.cashierPreferencesColorBlindnessOptionRadioButtonContainer}
          >
            <MuiButton
              data-testid='tritanopia-image-button'
              className={classes.cashierPreferencesOptionRadioButton}
              centerRipple
              onClick={() => {
                setConstrastLevel(CashierPreferenceLevel.Three);
              }}
            >
              Tritanopia Mode
              <RadioButton isSelected={constrastLevel === CashierPreferenceLevel.Three} />
            </MuiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface ColorBlindnessPreferencesProps {
  userPreferences: CashierPreferences;
  updatePreferences: (prefName: string, newValue: any) => void;
}

export default ColorBlindnessPreferences;
